import { EMPTY_OBJECT } from '../../../../constants/common'
import { useAsyncEntity } from '../../../Entity'

import { getRentalPortalListPermissions } from './useRentalPortalListPermissions.api'

export function useRentalPortalListPermissions({ resource }) {
  async function getProfileData() {
    return getRentalPortalListPermissions(resource)
  }

  const { entityData } = useAsyncEntity({ getProfileData })

  return { listPermissions: entityData?.permissions ?? EMPTY_OBJECT }
}
